import { Injectable } from '@angular/core';
import { DlistDto} from '@dabnet-kamu/libs/ui';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import {TmsTasinirGirisBakiyeService} from "../ctl-tms-tasinir-giris-bakiye.service";
import {BehaviorSubject} from "rxjs";

@Injectable()
export class Service {
  private _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsList$ = this._gridControlsList.asObservable();

    constructor(private dataCoreService: DataCoreService, private tmsTasinirGirisBakiyeService : TmsTasinirGirisBakiyeService) {}

  getData(islemFisRowData?:any, selectedDetayRowInfo?:any) {
            const dataSource = this.dataCoreService.getOData('vTmsTasinirGirisBakiye');
            dataSource.select([
            ]);

            const filterArr = [];

            if (islemFisRowData){
              filterArr.push(['Donem', '=', islemFisRowData.Donem]);
              filterArr.push(['AmbarKod', '=', islemFisRowData.AmbarKod]);
            }else{
              filterArr.push(['Donem', '=', this.tmsTasinirGirisBakiyeService.donem]);
              filterArr.push(['AmbarKod', '=', this.tmsTasinirGirisBakiyeService.ambarKod]);
            }
            if (selectedDetayRowInfo){
              filterArr.push(['DayanikliSicilKod', '=', selectedDetayRowInfo.DayanikliSicilKod]);
            }
            filterArr.push([['Bakiye', '>', 0],['ZimmetPersonelKod', '=', null]]);

            if (filterArr.length > 0) dataSource.filter(filterArr);


            return dataSource;
    }

}
